module.exports = __webpack_public_path__ + "img/coin-pay.f475490a.svg";